import { Cores } from 'src/componentes/styles/cores'

/**
 * Status do protocolo de rescisão.
 * Espelha o enum `StatusRescisao` do backend
 * (Ipgs.Educacional.Domain/Enums/StatusRescisao.cs). Os valores string batem
 * com os nomes do enum C# — que é como o backend serializa/aceita.
 */
export enum StatusRescisao {
  EmAberto = 'EmAberto',
  AguardandoRespostaFormulario = 'AguardandoRespostaFormulario',
  EmContatoAcademico = 'EmContatoAcademico',
  EmContatoFinanceiro = 'EmContatoFinanceiro',
  AguardandoRetornoAluno = 'AguardandoRetornoAluno',
  TrocaModalidade = 'TrocaModalidade',
  Inativo = 'Inativo',
  AguardandoTermoRescisao = 'AguardandoTermoRescisao',
  TermoAceito = 'TermoAceito',
  AguardandoPagamentoRescisao = 'AguardandoPagamentoRescisao',
  Rescisao = 'Rescisao',
  Conversao = 'Conversao',
  Reversao = 'Reversao'
}

export enum StatusRescisaoPorExtenso {
  EmAberto = 'Em aberto',
  AguardandoRespostaFormulario = 'Aguardando resposta do formulário',
  EmContatoAcademico = 'Em contato Acadêmico',
  EmContatoFinanceiro = 'Em contato Financeiro',
  AguardandoRetornoAluno = 'Aguardando retorno do aluno',
  TrocaModalidade = 'Troca de modalidade',
  Inativo = 'Inativo',
  AguardandoTermoRescisao = 'Aguardando termo de rescisão',
  TermoAceito = 'Termo aceito',
  AguardandoPagamentoRescisao = 'Aguardando pagamento da rescisão',
  Rescisao = 'Rescisão',
  Conversao = 'Conversão',
  Reversao = 'Reversão'
}

/** Cor de fundo do badge de status na listagem/detalhe. */
export const CorStatusRescisao: Record<
  keyof typeof StatusRescisao,
  { fundo: string; texto: string }
> = {
  EmAberto: { fundo: Cores.ATENCAO_FUNDO, texto: Cores.ATENCAO_ESCURO },
  AguardandoRespostaFormulario: {
    fundo: Cores.ATENCAO_FUNDO,
    texto: Cores.ATENCAO_ESCURO
  },
  EmContatoAcademico: {
    fundo: Cores.PRIMARIA_1_36,
    texto: Cores.PRIMARIA_1
  },
  EmContatoFinanceiro: {
    fundo: Cores.PRIMARIA_1_36,
    texto: Cores.PRIMARIA_1
  },
  AguardandoRetornoAluno: {
    fundo: Cores.SECUNDARIA_2_CLARO,
    texto: Cores.ATENCAO_ESCURO
  },
  TrocaModalidade: { fundo: Cores.CINZA_3, texto: Cores.CINZA_1 },
  Inativo: { fundo: Cores.CINZA_3, texto: Cores.CINZA_2 },
  AguardandoTermoRescisao: {
    fundo: Cores.ATENCAO_FUNDO,
    texto: Cores.ATENCAO_ESCURO
  },
  TermoAceito: {
    fundo: Cores.ATENCAO_FUNDO,
    texto: Cores.ATENCAO_ESCURO
  },
  AguardandoPagamentoRescisao: {
    fundo: Cores.ATENCAO_FUNDO,
    texto: Cores.ATENCAO_ESCURO
  },
  Rescisao: { fundo: Cores.PERIGO_ERRO_FUNDO, texto: Cores.PERIGO_ERRO_ESCURO },
  Conversao: { fundo: Cores.SUCESSO_FUNDO, texto: Cores.SUCESSO_ESCURO },
  Reversao: { fundo: Cores.SUCESSO_FUNDO, texto: Cores.SUCESSO_ESCURO }
}

export enum SetorRescisao {
  Academico = 'Academico',
  Financeiro = 'Financeiro'
}

export enum SetorRescisaoPorExtenso {
  Academico = 'Acadêmico',
  Financeiro = 'Financeiro'
}

/**
 * Etapas do wizard do aluno (4 telas — §3 da PROPOSTA).
 * Ainda não há endpoint que devolva a etapa atual do protocolo — quando o
 * backend do wizard subir (TM-5), mapear o status/etapa retornado para estes
 * valores no orquestrador do wizard.
 */
export enum EtapaWizardRescisao {
  Avisos = 1,
  Valores = 2,
  Dados = 3,
  Confirmacao = 4
}
